﻿import { defineComponent } from 'vue';

import { request_password_reset } from "../../booking_engine/objects/agent/identity/v1_3/reguest_password_reset"
import { response_password_reset } from "../../booking_engine/objects/agent/identity/v1_3/response_password_reset"

import { Agent_Login } from "../../booking_engine/services/agent_login";
import login_alert from "../login/login_alert.vue";

let Login: Agent_Login = new Agent_Login();

export default defineComponent({
    components: {
        login_alert
    },
    props: {
    },
    data() {
        return {
            Request_Password_Reset: new request_password_reset(),
            resetting: false as boolean,
            message: "" as string,
            message_type: "error" as 'error' | 'success',
            reset_sent: false as boolean
        }
    },
    methods: {
        async Reset_Password() {
            if (this.resetting) {
                return;
            }

            if ((this.Request_Password_Reset.user_name ?? "").trim() == "") {
                this.message_type = "error";
                this.message = "Please enter your agency email address.";
                return;
            }

            this.message = "";
            this.resetting = true;

            try {
                let Response_Password_Reset: response_password_reset = await Login.Password_Reset(this.Request_Password_Reset);

                if (Response_Password_Reset.password_reset == false) {
                    this.message_type = "error";
                    this.message = Response_Password_Reset.message || "We couldn't reset your password. Please check the email address and try again.";
                } else {
                    this.message_type = "success";
                    this.message = "We've emailed you a link to reset your password. Please check your inbox.";
                    this.reset_sent = true;
                }
            } catch {
                this.message_type = "error";
                this.message = "We couldn't reach the login service. Please check your connection and try again.";
            } finally {
                this.resetting = false;
            }
        },
        Register() {
            this.$router.push('/login/register');
        },
        Login() {
            this.$router.push('/login');
        },
        getContactInfo(): string {
            if (import.meta.env.VITE_DEFAULT_CONTACT_LOGIN_TEXT != undefined) {
                return String(import.meta.env.VITE_DEFAULT_CONTACT_LOGIN_TEXT);
            }
            else {
                return String(import.meta.env.VITE_DEFAULT_CONTACT_TEXT);
            }
        },
        hide_new_agent_link(): boolean {
            if (import.meta.env.VITE_HIDE_NEW_AGENT_LINK == "true") {
                return true;
            }
            else {
                return false;
            }
        }
    },
    mounted() {
    }
});